export default "__VITE_ASSET__X0J0VmbE9Y6eehvFaNyYWw__ 480w, __VITE_ASSET__hBLucboj$p4GA1VBUKy2jQ__ 770w";